<template>
  <div>
    <get-started-modal
      v-if="displayingModalName === 'get-started'"
      @clickedRequestTempPin="displayingModalName = 'temporary-pin'" />
    <enter-passcode-modal 
      v-else-if="displayingModalName === 'enter-passcode'"
      @clickedForgotPin="displayingModalName = 'temporary-pin'" />
    <temporary-pin-code-modal 
      v-else-if="displayingModalName === 'temporary-pin'"
      :member-access-code.sync="memberAccessCode"
      @validTemporaryCode="displayingModalName = 'create-passcode'" />
    <create-passcode-modal
     v-else-if="displayingModalName === 'create-passcode'"
     :member-access-code="memberAccessCode"/>
  </div>
</template>

<script>
  import Modal from '../../components/shared/Modal'
  import PasscodeInput from '../../components/shared/PasscodeInput'
  import GetStartedModal from './GetStartedModal'
  import EnterPasscodeModal from './EnterPasscodeModal.vue'
  import TemporaryPinCodeModal from './TemporaryPinCodeModal.vue'
  import CreatePasscodeModal from './CreatePasscodeModal.vue'

  export default {
    name: "Passcode",

    data(){
      return {
        displayingModalName: '',
        memberAccessCode: null
      }
    },

    components: { 
      CreatePasscodeModal,
      EnterPasscodeModal,
      GetStartedModal,
      Modal,
      PasscodeInput,
      TemporaryPinCodeModal,
    },

    created(){
      if(this.$route.query.f == 'true'){
        this.displayingModalName = 'enter-passcode'
      }else{
        this.displayingModalName = 'get-started'
      }
    }
  }
</script>